import {
  CreateAssessmentWithAttachmentsParams,
  createAssessmentWithAttachments,
} from "api/api";
import { useMutation } from "react-query";
import { MUTATION_KEYS } from "store/constants";

import { handleAxiosError } from "store/util";

const createAssesment = async ({
  locationId,
  reportId,
  recommendationId,
  body,
}: CreateAssessmentWithAttachmentsParams) => {
  return await createAssessmentWithAttachments(
    locationId,
    reportId,
    recommendationId,
    body
  );
};

export function useCreateAssesment() {
  return useMutation(createAssesment, {
    mutationKey: MUTATION_KEYS.createAssesment,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
